module.exports = __webpack_public_path__ + "img/ring.png";